import { gql } from "@apollo/client";

export const GET_RAP_INSTANCES = gql`
  query rap_instances {
    rap_instances {
      rap_instances {
        id
        name
        proxy
        enabled
        last_connected_time
        created_time
        created_by
        status
      }
    }
  }
`;
